import Vue from 'vue'
import App from './App.vue'
import VueCompositionAPI from '@vue/composition-api'
if (process.env.NODE_ENV === 'development') {
  declare global {
    interface Window { $: any; jQuery: any; }
  }
  window.$ = window.jQuery = require('jquery')
  require('@fancyapps/fancybox')
}

Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#cupboard_calculator')
